<div class="text-center">
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon class="menu-button"
              matTooltipPosition="right"
              matTooltip="FAQ actions">
      more_horiz
    </mat-icon>
  </button>
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="onEditClick()" data-testid="edit-faq-button">
    <mat-icon class="dark-grey menu-icon">edit</mat-icon>
    <span class="dark-grey menu-text">Edit FAQ</span>
  </button>

  <mat-divider></mat-divider>

  @if (faq.Shared) {
    <button mat-menu-item (click)="onMakeGameSpecificClick()">
      <mat-icon class="dark-grey menu-icon">videogame_asset</mat-icon>
      <span class="dark-grey menu-text">Convert to Game-Specific</span>
    </button>
  } @else {
    <button mat-menu-item (click)="onManageGamesClick()">
      <mat-icon class="dark-grey menu-icon">settings</mat-icon>
      <span class="dark-grey menu-text">Manage Games</span>
    </button>

    <mat-divider></mat-divider>

    <button mat-menu-item (click)="onMakeSharedClick()">
      <mat-icon class="dark-grey menu-icon">public</mat-icon>
      <span class="dark-grey menu-text">Convert to Shared</span>
    </button>
  }
</mat-menu>
